import { PLATFORM_ENVIRONMENT } from './platform-environment';

export const ENABLE_DEBUG_FEATURES = PLATFORM_ENVIRONMENT.isDevelopment || PLATFORM_ENVIRONMENT.isTest;
